import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import { Ripple } from 'vuetify/lib/directives'

Vue.use(Vuetify, {
  directives: {
    Ripple
  }
})

export default new Vuetify({
  icons: {
    iconfont: 'md'
  },

  theme: {
    themes: {
      light: {
        primary: '#1e345d',
        accent: '#f0a73a',
        secondary: '#436199',
        error: '#FF5252',
        info: '#0d5656',
        success: '#127312',
        warning: '#FFC107',
        dark: '#1a1a1d',

        // Custom tags to be decided
        menuSelectedColour: '#1976d2', // Colour of clicked links in side bar before custome colour theme implemented

        // Task Step colours
        initiationColour: '#b4b4b4',
        planningColour: '#f8da36',
        executionColour: '#2196f3',
        closeOutColour: '#67df91',
        flaggedColour: '#ff5b5b'

      }
    }
  }
})
